import React, { memo, useCallback } from 'react';
import { AnimationPlayer, PressableIcon, Box, Text } from '@bonanza-social/moonlight';
import { useGlobalAlert } from '../hooks';
import { useDispatch } from '@bonanza-social/toolkit/state';
import { acknowledgeGlobalAlert } from '../state';
import animations from './animations';

const GlobalAlert = () => {
  const { text, showGlobalAlert } = useGlobalAlert();
  const dispatch = useDispatch();

  const handleClose = useCallback(() => {
    dispatch(acknowledgeGlobalAlert());
  }, [dispatch]);

  if (!showGlobalAlert) {
    return null;
  }

  return (
    <Box position="relative" width="100%" testID="global-alert">
      <Box
        position="absolute"
        inset={0}
        variant="gradient"
        gradient="warningBackground"
        opacity={0.9}
      />

      <Box
        position="relative"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        paddingVertical="space-200"
        paddingHorizontal="space-400"
      >
        <AnimationPlayer
          source={animations.bellHeart}
          loop={true}
          sizeX={24}
          sizeY={24}
        />
        <Text
          variant="body-s-semi"
          marginLeft="space-300"
          color="darkSurfacePrimary"
          flex={1}
        >
          {text}
        </Text>
        <PressableIcon
          name="close"
          width="space-500"
          height="space-500"
          color="darkSurfacePrimary"
          onPress={handleClose}
        />
      </Box>
    </Box>
  );
};

export default memo(GlobalAlert);
